import React from 'react';
import withInit from 'WithInit';
import BaseModal from 'Modals/BaseModal';
import connectModal from 'Modals/enhancers/ConnectModal';
import ModalTypeEnum from 'Modals/ModalConstants';

const FinishLaterModalWithRedux = connectModal(BaseModal);

class FinishLaterModal extends React.Component {
  static saveDocumentProgress() {
    window.localStorage.setItem(`staticSection-${window.SessionManager.id}`, JSON.stringify(window.ReactCompatibility.getStaticBuilderCurrentStep()));
    window.location.assign(`/newAccountForDoc.php${window.location.search}&redirectAction=builder`);
  }

  render() {
    return (
      <FinishLaterModalWithRedux
        modalType={ModalTypeEnum.STATIC_FINISH_LATER}
        activeModal="static-finish-later"
        includeHeaderCloseButton
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        bodyContent={(
          <React.Fragment>
            <img
              alt="document-illustration"
              src="/images/finish-later-modal-document-icon.png"
              className="finish-later-modal-icon"
            />
            <p className="finish-later-modal-question">
              Do you want to save this document and finish later?
            </p>
            <p className="finish-later-modal-text">You will be redirected to create an account</p>
            <button
              className="finish-later-modal-cta btn btn-primary"
              onClick={FinishLaterModal.saveDocumentProgress}
            >
              Yes, Save & Finish Later
            </button>
          </React.Fragment>
        )}
        footerContent={null}
      />
    );
  }
}

export default withInit(FinishLaterModal, true);



// WEBPACK FOOTER //
// ./src-react/Modals/FinishLater/index.jsx